import React, { useCallback, PureComponent } from 'react';
import monsterNames from '../data/names';
import breeding from '../data/breeding';
import monsterImages from '../data/photoList';
import { get } from 'lodash';
import FixedHeaderTable from '../components/FixedHeaderTable';
import { MonsterRenderer } from '../components/MonsterRenderer';
import { MonsterHeaderRenderer } from '../components/MonsterHeaderRenderer';

function generateMonsterTable(pedigreeMonsters, secondaryMonsters) {
  return {
    leftHeaders: pedigreeMonsters,
    topHeaders: secondaryMonsters,
    data: pedigreeMonsters.map(pedigree => {
      return secondaryMonsters.map(secondary => {
        return get(breeding, [pedigree, secondary]);
      })
    })
  };
}

export default class MonsterTable extends React.Component {
  render() {
    const { style, pedigrees, secondaries, cellWidth, cellHeight } = this.props;

    const data = generateMonsterTable(pedigrees, secondaries);
    console.log('rendering', data);

    return (
      <FixedHeaderTable
        style={style ? Object.assign({}, styles.container, style) : styles.container}
        cellWidth={cellWidth || 65}
        cellHeight={cellHeight || 56}
        cellRenderer={MonsterRenderer}
        topHeaderRenderer={MonsterHeaderRenderer}
        leftHeaderRenderer={MonsterHeaderRenderer}
        topHeaders={data.topHeaders}
        leftHeaders={data.leftHeaders}
        data={data.data}
      />
    );
  }
}

const styles = {
  container: {
    overflow: 'auto',
    height: '100%',
    width: '100%',
  }
};
